"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _slice = require("@lce/slice");

var _cart = require("@lce/cart");

var _api = require("@lce/api");

var _i18n = require("@lce/i18n");

var _AccountMenu = _interopRequireDefault(require("../AccountMenu"));

var _AccountMenu_V = _interopRequireDefault(require("../AccountMenu_V2"));

var _Logo = _interopRequireDefault(require("../Logo"));

var Styled = _interopRequireWildcard(require("./Desktop.style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var Desktop = function Desktop(_a) {
  var hideAccount = _a.hideAccount,
      hideCart = _a.hideCart;

  var _b, _c;

  var settings = (0, _api.useSettings)().data;
  var t = (0, _i18n.useTranslation)().t;
  var isAccountMenuV2 = (_b = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _b === void 0 ? void 0 : _b.ACCOUNT_V2;
  var AccountPopover = isAccountMenuV2 ? _AccountMenu_V["default"].Popover : _AccountMenu["default"].Popover;
  var showDeals = (_c = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _c === void 0 ? void 0 : _c.DEALS;
  return React.createElement(Styled.Desktop, null, React.createElement(Styled.Header, null, React.createElement(_slice.Box, {
    flex: "1 1 auto"
  }, React.createElement(_Logo["default"], null)), showDeals ? React.createElement(_slice.Box, {
    "data-testid": "header__desktop__deals",
    mr: 8
  }, React.createElement(Styled.Deals, {
    "data-testid": "header__deals",
    href: "/deals"
  }, "" + t('Header.Deals'))) : null, !hideAccount ? React.createElement(_slice.Box, {
    "aria-controls": "header__desktop__account",
    "data-testid": "header__desktop__account",
    mr: 8
  }, React.createElement(AccountPopover, null)) : null, !hideCart ? React.createElement(_slice.Box, {
    "aria-controls": "header__desktop__account",
    "data-testid": "header__desktop__cart"
  }, React.createElement(_cart.Cart.Popover, null)) : null));
};

var _default = Desktop;
exports["default"] = _default;